<template>
  <div class="visually-hidden-focusable overflow-hidden p-3 bg-body">
    <a class="px-2" href="#main-content">Skip to main content</a>
  </div>

  <SiteHeader />

  <main id="main-content">
    <slot />
  </main>

  <SiteFooter />
</template>

<script setup>
import { useCustomerComponent } from '@shared/composables/CustomerComponent'

const SiteHeader = useCustomerComponent('SiteHeader')
const SiteFooter = useCustomerComponent('SiteFooter')
</script>
